import { render, staticRenderFns } from "./FormsTable.vue?vue&type=template&id=7d816122&scoped=true&"
import script from "./FormsTable.vue?vue&type=script&lang=js&"
export * from "./FormsTable.vue?vue&type=script&lang=js&"
import style0 from "./FormsTable.vue?vue&type=style&index=0&id=7d816122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d816122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d816122')) {
      api.createRecord('7d816122', component.options)
    } else {
      api.reload('7d816122', component.options)
    }
    module.hot.accept("./FormsTable.vue?vue&type=template&id=7d816122&scoped=true&", function () {
      api.rerender('7d816122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/FormsTable.vue"
export default component.exports